import React from "react";
import { Ban, CheckCircle } from "lucide-react";

interface QuoteActionButtonsProps {
    onAccept: () => void;
    onReject: () => void;
}

const QuoteActionButtons: React.FC<QuoteActionButtonsProps> = ({ onAccept, onReject }) => (
    <div className="flex space-x-3">
        <button
            onClick={onReject}
            className="inline-flex items-center px-4 py-2 border border-slate-300 text-sm font-medium rounded-md text-slate-700 bg-white hover:bg-slate-50 shadow-sm hover:cursor-pointer"
        >
            <Ban className="h-4 w-4 mr-2" /> Reject Quote
        </button>
        <button
            onClick={onAccept}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 shadow-sm hover:cursor-pointer"
        >
            <CheckCircle className="h-4 w-4 mr-2" /> Respond to Quote
        </button>
    </div>
);

export default QuoteActionButtons;